/* eslint-disable max-len */
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import GlobalContext from '../Context/GlobalContext'
import { motion } from 'framer-motion';

export default function CardHeaders({ children, header, paths, back, noIcon, OnlyHeader, storeButton, activePath, pathurls }) {
    const navigate = useNavigate()
    const { setShowStore, sideBar } = useContext(GlobalContext)

    function cumulativeSum(arr) {
        let result = [];
        let sum = '';
        for (let str of arr) {
            sum += str;
            result.push(sum);
        }
        return result;
    }

    return (
        // <div className={`${!sideBar ? 'ml-[224px]': 'ml-[70px]'} overflow-x-hidden w-customw1`}>
        <motion.div
            className={`overflow-x-hidden ${!sideBar ? 'w-customw1' : 'w-customw2'}`}
            animate={{
                marginLeft: sideBar ? "70px" : "224px",
            }}
            transition={{ duration: 0.3 }}
        >
            <div className={`shadow-lg sticky top-0 right-0 pt-5 pb-5 flex flex-col justify-center bg-white w-full h-[110px] z-[9]`}>
                <div className='flex justify-between items-center w-full'>
                    <div className='flex flex-col  justify-center'>
                        {OnlyHeader === undefined && paths && <p className="text-[#4B4B4B] pb-4 pl-8 cursor-pointer">
                            {paths.map((path, index) => <span key={index} data-testid={path} onClick={() => navigate(`${cumulativeSum(pathurls.slice(0, index + 1)).pop()}`)} className="text-sm font-normal text-[#4B4B4B]">
                                {path} / {' '}
                            </span>)}
                            {activePath !== undefined && <span className="text-sm font-normal text-[#1F1F1F]">
                                {activePath}
                            </span>
                            }
                        </p>}

                        {header && <div className="flex items-center space-x-[14px] pl-6">
                            {noIcon === undefined && <img src="/assets/images/chevron-left.svg" alt="" data-testid="back-btn" onClick={() => navigate(back)} />}
                            <h1 className="font-playfair text-[#4B4B4B] text-xl font-[600]">
                                {header}
                            </h1>
                        </div>}
                    </div>
                </div>

            </div>


            {children}


        </motion.div>
    )
}
